import { Pipe, PipeTransform } from '@angular/core';

let moment = require('moment');

@Pipe({ name: 'dateFormat', standalone: false })
export class MomentPipe implements PipeTransform {
  transform(value: Date, dateFormat: string): any {
    return moment(value).format(dateFormat);
  }
}
